<template>

    <div class="swiper-container" id="PhotoTestomonialSlider">

        <div class="encart">
            <h3 class="titre">Découvrez et partagez</h3>
            <p>Rejoignez la communauté Grands Espaces et partagez avec tous les croisiéristes les plus beaux clichés de vos séjours !</p>
            <slot name="link"></slot>
        </div>

        <div class="swiper-wrapper">
            <slot name="slides"></slot>
        </div>

        <div class="swiper-arrows">
            <div class="button-prev btn-prev"></div>
            <div class="button-next btn-next"></div>
        </div>
        <slot name="caption"></slot>

    </div>

</template>

<script>
    import $ from 'jquery';
    import Swiper from 'swiper';
    import {debounce} from 'lodash';
    import {breakpointDown} from '../../libs/Breakpoints';

    export default {
        props: {

        },
        data() {
            return {
                swiperShip: null,
                numbreOfSlide: 0,
            };
        },
        computed:{
            isMobile(){
                return this.$root.isMobile
            },
        },
        methods: {
            initSwiper(){

                // Init
                this.swiperShip = new Swiper ('#PhotoTestomonialSlider',{
                    effect: "fade",
                    autoHeight: true,
                    threshold: 40,
                    speed: 300,
                    virtualTranslate: true,
                    grabCursor: true,
                    lazy: {
                        loadPrevNext: true,
                    },
                    preloadImages: false,
                    navigation: {
                        nextEl: '#PhotoTestomonialSlider .button-next',
                        prevEl: '#PhotoTestomonialSlider .button-prev',
                    },
                    pagination: {
                        el: '#PhotoTestomonialSlider .swiper-pagination',
                        type: 'fraction',
                        renderFraction: function (currentClass, totalClass) {
                            return '<span class="' + currentClass + '"></span>' +
                                '<span class="' + totalClass + '"></span>';
                        },
                        formatFractionCurrent: function (number) {
                            return ("0" + number).slice(-2)
                        },
                        formatFractionTotal: function (number) {
                            return ("0" + number).slice(-2)
                        },

                    },


                })

                this.numbreOfSlide = this.swiperShip.slides.length

                this.swiperShip.on('slideNextTransitionStart slidePrevTransitionStart', ()=> {
                    this.clearPagination()
                    this.changeCaption()
                });
                this.changeCaption()
                this.clearPagination()

            },
            clearPagination(){

                // Efface le bouton Suivant en fin de course
                if(this.swiperShip.activeIndex == (this.numbreOfSlide - 1)){
                    $('#PhotoTestomonialSlider .button-next').addClass('disabled')
                }else{
                    $('#PhotoTestomonialSlider .button-next').removeClass('disabled')
                }

                // Efface le bouton Précedent en début de course
                if(this.swiperShip.activeIndex == 0){
                    $('#PhotoTestomonialSlider .button-prev').addClass('disabled')
                }else{
                    $('#PhotoTestomonialSlider .button-prev').removeClass('disabled')
                }

            },
            changeCaption: debounce(function () {
                $('#PhotoTestomonialSlider p.caption').hide().html($('#PhotoTestomonialSlider .swiper-slide-active .photo').attr( 'data-alt' )).fadeIn(1000)
            }, 500),

        },
        mounted() {
            this.initSwiper()

        },
        created() {

        },
        destroyed() {

        },
    }
</script>




// WEBPACK FOOTER //
// assets/js/components/magazine/PhotoTestimonialCarousel.vue